import React from 'react'
import { observer } from 'mobx-react'
import { restaurantConfig } from 'restaurant'
import { ConfirmModal } from '@cps'
import { ProductImage } from 'components'
import './index.scss'

const CanNotTogoModal: React.FC<any> = (props) => {
  const { cartItems } = props

  const productGroup = (productGroups) => {
    return (
      <div className='item-groups'>
        {
          productGroups?.map(group => (
            <div key={group.no} className='product-group'>
              {
                group?.productGroupDetails.map(product => (
                  <div key={product.pk} className='product-group-item'>
                    <strong>{product.name}</strong>
                    <small>{product.optionStr}</small>
                    {!product.isCanTogo && <span className='disable-togo'>{i18n.t('newCart.productCanNotTogo')}</span>}
                  </div>
                ))
              }
            </div>
          ))
        }
      </div>
    )
  }

  const renderProduct = (cartItem: any[]) => {
    return cartItem.map((item: any) => {
      return (
        <div className='canot-togo-item' key={item.pk}>
          <ProductImage color={!item.pic && restaurantConfig.displayMode === 'waterfall' ? item.productNo : ''} width={40} imgSrc={item.pic} />
          <div className='product-info'>
            <div className='product-name'>
              <strong>{item.name}</strong>
              <div className='product-option'>{item.optionStr}</div>
            </div>
            {item.productGroups?.length && productGroup(item.productGroups)}
          </div>
        </div>
      )
    })
  }

  return (
    <ConfirmModal
      title={i18n.t('newCart.canNotTogoTips')}
      cancelText={i18n.t('common.cancel')}
      confirmText={i18n.t('newCart.deleteProduct')}
      children={(
        <div className='canot-togo-list'>
          {renderProduct(cartItems)}
        </div>
      )}
      className='canot-togo-modal'
    />
  )
}

export default observer(CanNotTogoModal)
